module.exports = __webpack_public_path__ + "static/media/M2.a6c0dc86.jpg";